import { ReactComponent as Logo } from "assets/icons/scraperapi-logo.svg";
import { ReactComponent as RebrandLogo } from "assets/icons/scraperapi-logo-2026.svg";
import { rebrandSvg } from "components/FeatureSwitch/rebrandSvg";

// Today's logo, or the 2026 rebrand logo when REACT_APP_USE_REBRAND_2026 is on.
const ScraperAPILogo = rebrandSvg(Logo, RebrandLogo);

export default ScraperAPILogo;
